module.exports = __webpack_public_path__ + "static/media/tonye_art.4c2ac9fe.jpg";